// https://confluence.vk.team/pages/viewpage.action?pageId=1560502237
export enum CloudActions {
    // Read
    FILE_READ = 'file_read',
    FOLDER_LIST = 'folder_list',
    SEARCH = 'search',
    HISTORY_VIEW = 'history_view',

    // Create
    FOLDER_CREATE = 'folder_create',
    FILE_CREATE = 'file_create',
    MOVE = 'move',
    COPY = 'copy',

    // Download
    FILE_DOWNLOAD = 'file_download',
    LIST_DOWNLOAD = 'list_download',

    // Share
    LIST_CREATE = 'link_create',
    LINK_CONFIG = 'link_config',
    LINK_REMOVE = 'link_remove',
    SEND = 'send',

    // Edit
    FILE_EDIT = 'file_edit',
    FILE_VERSION_VIEW = 'file_version_view',
    FILE_VERSION_RESTORE = 'file_version_restore',
    LINK_RIGHTS = 'link_rights',
    RENAME = 'rename',

    // Delete
    DELETE = 'delete',
    TRASHBIN_VIEW = 'trashbin_view',
    TRASHBIN_EMPTY = 'trashbin_empty',
    RESTORE = 'restore',
}
